export default ({
  state: {
    // Configuracion General \\
    // Empresa \\
    DepartamentoForm: [
      { field: 'text', type: 'text', name: 'Clave', nameid: 'clave', rules: true, cols: 4 },
      { field: 'text', type: 'text', name: 'Nombre Departamento', nameid: 'nombre', rules: true, cols: 8 }
    ],
    nivelesForm: [
      { field: 'text', type: 'text', name: 'Nivel', nameid: 'nivel', rules: true, cols: 12 },
      { field: 'number', type: 'number', name: 'Maximo', nameid: 'maximo', rules: true, cols: 6 },
      { field: 'number', type: 'number', name: 'Minimo', nameid: 'minimo', rules: true, cols: 6 },
      { field: 'selectDataServer', name: 'Zona', nameid: 'zona_id', url: '/nomina/config/zonas/show', rules: true, cols: 12 }
    ],
    incidenciaForm: [
      { field: 'selectGroupDataServer', name: 'Periodo', nameid: 'ejercicio_id', url: '/nomina/config/ejercicio/periodos', rules: true, cols: 12, default: true },
      { field: 'searchDataServer', name: 'Colaborador', nameid: 'adscripcion_id', url: '/nomina/empleados-plazas/find', itemValue: 'id', rules: true, cols: 12 },
      { field: 'number', type: 'number', name: 'Asistencia', nameid: 'horas_asistencia', cols: 6 },
      { field: 'number', type: 'number', name: 'Faltas', nameid: 'horas_faltas', cols: 6 }
    ],
    fileIncidencia: [
      { field: 'selectGroupDataServer', name: 'Departamento', nameid: 'departamento_id', url: '/config/departamentos/show', rules: true, cols: 12, default: true },
      { field: 'fileInputDataServer', name: 'Layout Incidenias', nameid: 'file', rules: true, cols: 12 }
    ],
    importAsistenciaForm: [
      { field: 'selectGroupDataServer', name: 'Departamento', nameid: 'departamento_id', url: '/config/departamento/show', rules: true, cols: 12, default: true },
      { field: 'fileInputDataServer', name: 'Layout Incidenias', nameid: 'file', rules: true, cols: 12 }
    ],
    importIncidenciasForm: {
      field: 'fileDrapDrop',
      name: 'Cargar Excel de datos',
      nameid: 'incidencias',
      rules: true,
      cols: 12,
      table: {
        header: {
          options: [
            { title: 'Exportar Layout', icon: 'mdi-file-download', color: 'success', action: 'exportData', code: 'libre', hidden: '' },
            { title: 'Cargar Nuevo Excel', icon: 'mdi-file-excel', color: 'primary', action: 'LoadData', code: 'no-libre' }
          ],
          titles: [
            { text: 'Cve Empleado', value: 'cve_empleado', class: 'black--text' },
            { text: 'Cve Centro de Trabajo', value: 'cct', class: 'black--text' },
            { text: 'RFC', value: 'rfc', class: 'black--text' },
            { text: 'Nombre Completo', value: 'nombre', class: 'black--text' },
            { text: 'Fecha', value: 'fecha', class: 'black--text' },
            { text: 'Horas / Dias', value: 'numero_horas', class: 'black--text' }
          ],
          loading: false
        },
        body: {
          data: [],
          actions: []
        },
        footer: {
          paging: true
        }
      }
    },
    cuentasEmpleadosForm: [
      { field: 'searchDataServer', name: 'Colaborador', nameid: 'cve_empleado', url: '/rh/empleado/find', itemValue: 'cve_empleado', rules: true, cols: 12 },
      { field: 'selectDataServer', name: 'Banco', nameid: 'banco_id', url: '/nomina/bancos/show', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Cuenta Bancaria', nameid: 'cuenta', rules: false, cols: 6 },
      { field: 'text', type: 'text', name: 'Clabe Bancaria', nameid: 'clabe', rules: false, cols: 6 }
    ],
    usersForm: [
      { field: 'text', type: 'text', name: 'Nombre Usuario', nameid: 'usuario', rules: true, cols: 12 },
      { field: 'searchDataServer', name: 'Colaborador', nameid: 'cve_empleado', url: '/rh/empleado/find', itemValue: 'cve_empleado', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Correo Electronico', nameid: 'email', rules: true, cols: 12 },
      { field: 'text', type: 'password', name: 'Contraseña', nameid: 'password', rules: true, cols: 12 },
      { field: 'text', type: 'password', name: 'Confirmar Contraseña', nameid: 'confirmpassword', rules: true, cols: 12 }
    ],
    roleForm: [
      { field: 'text', type: 'text', name: 'Clave Role', nameid: 'slug', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Nombre Role', nameid: 'nombre', rules: true, cols: 12 }
    ],
    assignRoles: [
      { field: 'viewText', name: 'Nombre Colaborador', nameid: 'NombreCompleto', cols: 12 },
      { field: 'viewText', name: 'Nombre Usuario', nameid: 'usuario', cols: 12 },
      { field: 'viewTextList', name: 'Rol Asignado', nameid: 'roles', action: 'removeRole', color: 'info', itemnameid: 'nombre', cols: 12 },
      { field: 'selectDataServer', name: 'Rol', nameid: 'rol_id', url: '/config/auth/roles/show', rules: true, cols: 12 }
    ],
    updateAdscripcion: [
      { field: 'searchDataServer', name: 'Colaborador', nameid: 'cve_empleado', url: '/rh/empleado/find', cols: 12, rules: true, itemValue: 'cve_empleado', action: 'findBillEmployee', isHidden: ['cuenta_id'] },
      { field: 'selectDataServer', name: 'Cuenta', nameid: 'cuenta_id', url: '/nomina/cuentas/show', cols: 12, rules: true, default: '/nomina/cuentas/show-by-employee/', params: {}, hidden: true },
      { field: 'selectDataServer', name: 'Plaza', nameid: 'plaza_id', url: '/nomina/config/plazas/show', cols: 12, rules: true },
      { field: 'searchDataServer', name: 'Departamento', nameid: 'departamento_id', url: '/config/departamentos/find', cols: 12, rules: true, itemValue: 'id' }
    ],
    contactoForm: [
      { field: 'searchDataServer', name: 'Colaborador', nameid: 'cve_empleado', url: '/rh/empleado/find', cols: 12, rules: true, itemValue: 'cve_empleado', action: 'findBillEmployee' },
      { field: 'radioButton', name: 'Tipo Contacto', nameid: 'tipo', items: ['TELEFONO', 'CORREO', 'MOVIL'], rules: true, row: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Contacto', nameid: 'contacto', rules: true, cols: 12 }
    ],
    direccionForm: [
      { field: 'searchDataServer', name: 'Colaborador', nameid: 'cve_empleado', url: '/rh/empleado/find', cols: 12, rules: true, itemValue: 'cve_empleado', action: 'findBillEmployee' },
      { field: 'text', type: 'text', name: 'Calle', nameid: 'calle', rules: true, cols: 3 },
      { field: 'text', type: 'text', name: 'Numero', nameid: 'numero', rules: true, cols: 3 },
      { field: 'text', type: 'text', name: 'Cruzamiento 1', nameid: 'cruzamiento1', rules: true, cols: 3 },
      { field: 'text', type: 'text', name: 'Cruzamiento 2', nameid: 'cruzamiento2', rules: true, cols: 3 },
      { field: 'text', type: 'text', name: 'Codigo postal', nameid: 'cp', rules: true, cols: 6 },
      { field: 'searchDataServer', name: 'Localidad', nameid: 'localidad_id', url: '/config/cat/localidad/find', itemValue: 'id', method: true, cols: 6 }
    ],
    loadImageForm: [
      { field: 'viewText', name: 'Nombre Colaborador', nameid: 'NombreCompleto', cols: 12 },
      { field: 'fileInputDataServer', name: 'Cargar Imagen', nameid: 'file', rules: true, cols: 12 }
    ],
    horarioColaboradorForm: [
      { field: 'number', type: 'number', name: 'Total de Horas', nameid: 'total_horas', rules: true, cols: 6 },
      { field: 'selectDataServer', name: 'Ejercicio', nameid: 'ejercicio_id', url: '/nomina/config/ejercicio/show', rules: true, cols: 12 },
      { field: 'searchDataServer', name: 'Colaborador', nameid: 'adscripcion_id', url: '/nomina/empleados-plazas/find', itemValue: 'id', rules: true, cols: 12 },
      { field: 'textDatePicker', name: 'Fecha de Inicio', nameid: 'fInicial', cols: 6 },
      { field: 'textDatePicker', name: 'Fecha de Termino', nameid: 'fFinal', cols: 6 },
      { field: 'number', type: 'number', name: 'Minutos de Tolerancia', nameid: 'min_tolerancia', rules: true, cols: 6 },
      { field: 'number', type: 'number', name: 'Minutos para Aplicar Faltas', nameid: 'min_falta', rules: true, cols: 6 },
      { field: 'number', type: 'number', name: 'Minutos para Aplicar Retardo', nameid: 'min_retardo', rules: true, cols: 6 }
    ],
    horarioDiaForm: [
      { field: 'checkbox', name: 'Dia de la Semana', nameid: 'dia', items: ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado', 'domingo'], row: true, rules: true, cols: 12 },
      { field: 'radioButton', name: 'Tipo de Horario', nameid: 'tipo_horario', items: ['DIURNA', 'INTERMEDIO', 'NOCTURNA'], row: true, rules: true, cols: 12 },
      { field: 'textTimePicker', name: 'Hora de Entrada', nameid: 'he', rules: true, cols: 6 },
      { field: 'textTimePicker', name: 'Horas de Salida', nameid: 'hs', rules: true, cols: 6 }
    ],
    exporByDatestForm: [
      { field: 'textDatePicker', name: 'Fecha Inicio', nameid: 'fechainicio', cols: 6 },
      { field: 'textDatePicker', name: 'Fecha Final', nameid: 'fechafinal', cols: 6 }
    ],
    exporByDatetForm: [
      { field: 'textDatePicker', name: 'Fecha', nameid: 'fecha', cols: 12 }
    ],
    FilterExportAsistenciasForm: [
      { field: 'textDatePicker', name: 'Fecha Inicio', nameid: 'fechainicio', rules: true, cols: 6 },
      { field: 'textDatePicker', name: 'Fecha Final', nameid: 'fechafinal', cols: 6 },
      { field: 'searchDataServer', name: 'Colaborador', nameid: 'cve_empleado', itemValue: 'cve_empleado', url: '/rh/empleado/find', rules: true, cols: 12 }
    ],
    JustificarAsistenciaForm: [
      { field: 'searchDataServer', name: 'Colaborador', nameid: 'adscripcion_id', url: '/nomina/empleados-plazas/find', itemValue: 'id', readonly: true, rules: true, cols: 12 },
      { field: 'textDatePicker', name: 'Fecha a Justificar', nameid: 'fecha', cols: 4 },
      { field: 'selectDataServer', name: 'Tipo de Incidencia', nameid: 'tipo_incidencia_id', url: '/asistencia/tipo-incidencia/show', rules: true, cols: 8 },
      { field: 'text', type: 'text', name: 'Descripcion', nameid: 'descripcion', rules: true, cols: 12 }
    ]
  },
  getters: {
    // Configuracion General \\
    // Empresa \\
    get_Departamento_Form (state) {
      return state.DepartamentoForm
    },

    get_nivel_form (state) {
      return state.nivelesForm
    },
    get_incidencia_form (state) {
      return state.incidenciaForm
    },
    get_fileIncidencia (state) {
      return state.fileIncidencia
    },
    get_importAsistenciaForm (state) {
      return state.importAsistenciaForm
    },
    get_importIncidenciasForm (state) {
      return state.importIncidenciasForm
    },
    get_JustificarAsistenciaForm (state) {
      return state.JustificarAsistenciaForm
    },

    get_cuentasEmpleadosForm (state) {
      return state.cuentasEmpleadosForm
    },
    get_usersForm (state) {
      return state.usersForm
    },
    get_roleForm (state) {
      return state.roleForm
    },
    get_assignRoles (state) {
      return state.assignRoles
    },
    get_updateAdscripcion (state) {
      return state.updateAdscripcion
    },
    get_contactoForm (state) {
      return state.contactoForm
    },
    get_direccionForm (state) {
      return state.direccionForm
    },
    get_loadImageForm (state) {
      return state.loadImageForm
    },
    get_horarioColaboradorForm (state) {
      return state.horarioColaboradorForm
    },
    get_horarioDiaForm (state) {
      return state.horarioDiaForm
    },
    get_exporByDatestForm (state) {
      return state.exporByDatestForm
    },
    get_exporByDatetForm (state) {
      return state.exporByDatetForm
    },
    get_FilterExportAsistenciasForm (state) {
      return state.FilterExportAsistenciasForm
    }
  },
  mutations: {},
  actions: {}
})
